/**
 * Created by mgoria on 12/22/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdentityProviderTokenExpiredException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when identity provider token expired
 */
let IdentityProviderTokenExpiredException = exports.IdentityProviderTokenExpiredException = function (_Exception) {
  _inherits(IdentityProviderTokenExpiredException, _Exception);

  /**
   * @param {String} providerName
   * @param {Date} expireTime
   */
  function IdentityProviderTokenExpiredException(providerName, expireTime) {
    _classCallCheck(this, IdentityProviderTokenExpiredException);

    return _possibleConstructorReturn(this, (IdentityProviderTokenExpiredException.__proto__ || Object.getPrototypeOf(IdentityProviderTokenExpiredException)).call(this, `"${providerName}" access_token has expired on "${expireTime.toString()}".`));
  }

  return IdentityProviderTokenExpiredException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/Exception/IdentityProviderTokenExpiredException.js
// module id = 101
// module chunks = 0